export default "__VITE_ASSET__DlF3ox9O__"